import React from "react";
import OfferCard from "./Components/OfferCard.js";
import { ArrowRight } from "lucide-react";
import WhiteButton from "../../../../Components/WhiteButton.js";
import SectionHeader from "../../../../Components/SectionHeader.js";
import { useNavigate } from "react-router-dom";
import HorizontalScrollSection from "../../../../Components/HorizontalScrollSection.js";

const OfferingSection = () => {
  const navigate = useNavigate();
  const offersList = [
    {
      title: "DATA and AI STRATEGY",
      description:
        "We design, build, and implement Al platforms to establish a solid and secure foundation for the technical delivery of artificial intelligence. By expanding traditional data platforms with the necessary infrastructure, governance, and services, we enable Al models to operate at scale.",
      imageURL: "/images/offer-image-1.jpg",
    },
    {
      title: "GENERATIVE AI",
      description:
        "We develop Generative Al agents and tools to enhance business workflows, improve user experiences, automate tasks, and unlock new opportunities driving lasting impact and value.",
      imageURL: "/images/offer-image-2.jpeg",
    },
    {
      title: "AI CENTER OF EXCELLENCE",
      description:
        "Build, scale, and optimize Al with GCCs and CoEs. We drive innovation, efficiency, and compliance from strategy to execution.",
      imageURL: "/images/case-studies/3/case-image-0.jpeg",
    },
    {
      title: "ADVANCED ANALYTICS AND MACHINE LEARNING",
      description:
        "We harness Advanced Analytics and Machine Learning to convert raw data into actionable insights, empowering data-driven decision-making. By leveraging statistical models, deep learning, and parametric modeling, we uncover hidden patterns, predict trends, and optimize operations.",
      imageURL: "/images/offer-image-4.jpeg",
    },
  ];

  const shouldSpan = (position) => {
    return (
      position % 8 === 1 ||
      position % 8 === 4 ||
      position % 8 === 5 ||
      position % 8 === 0
    );
  };

  return (
    <section id="learn-more" className="flex flex-col md:flex-row min-h-screen">
      <div className="text-white flex-1 flex flex-col">
        {/* items-center */}
        <main className="flex-1 flex flex-col items-start md:items-center pt-[28%] md:py-[8%]">
          <SectionHeader
            childClassName="md:px-[2%] text-base md:text-lg"
            tagline="What we have to offer"
            title={
              <div>
                AI Powered Future, <br />
                Build for Innovation
              </div>
            }
            description="From Generative Al to Advanced Analytics, we build intelligent
            solutions that optimize workflows, enhance decision-making, and
            drive innovation at scale."
          />

          <div class="hidden md:grid justify-center md:grid-cols-3 gap-4 px-4 md:px-20 md:pb-12">
            {offersList.map((offers, index) => {
              const position = index + 1; // 1-based position
              return (
                <OfferCard
                  key={offers.title}
                  title={offers.title}
                  className={`${shouldSpan(position) ? "md:col-span-2" : ""}`}
                  imageUrl={offers.imageURL}
                  description={offers.description}
                />
              );
            })}
          </div>
          <WhiteButton
            className="hidden md:block"
            text="Explore More"
            icon={<ArrowRight />}
            onClick={() => navigate("/offerings")}
          />
        </main>

        <HorizontalScrollSection
          buttonTitle="Explore More"
          onClick={() => navigate("/offerings")}
          className="pb-[28%] md:hidden"
          child={offersList.map((offers, index) => {
            return (
              <OfferCard
                key={`card-${offers.title}-${index}`}
                title={offers.title}
                className={`inline-block min-w-[46vh] !h-[466px] `}
                imageUrl={offers.imageURL}
                description={offers.description}
              />
            );
          })}
        />
      </div>
    </section>
  );
};

export default OfferingSection;
